import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../Auth/useAuth";
import config from "../../config";
import "./Driver.css";
import DriverNavbar from "../DriverNavbar/DriverNavbar";
import AlertModal from "../AlertModal/AlertModal";

const fetchDriverTripsUrl = `${config.BASE_URL}/driver-trips`;
const updateTransitStatusUrl = `${config.BASE_URL}/update-transit-status`;

const Driver = () => {
  const [trips, setTrips] = useState([]);
  const [inTransitTrip, setInTransitTrip] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [transitStatus, setTransitStatus] = useState("");
  const [truckNo, setTruckNumber] = useState("");
  const [editRefs, setEditRefs] = useState({});
  const [formData, setFormData] = useState({
    source: "",
    destination: "",
  });

  const { username, setActiveModule } = useAuth();

  const [isLoading, setIsLoading] = useState(false);

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info",
  });

  // Modal handler functions
  const showModal = (title, message, type = "info") => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type,
    });
  };

  const closeModal = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
  };

  useEffect(() => {
    sessionStorage.setItem("actMod", "driver");
    setActiveModule(sessionStorage.getItem("actMod"));
  }, []);

  useEffect(() => {
    fetchTrips();
  }, []);

  const fetchTrips = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        fetchDriverTripsUrl,
        { username },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.data) {
        setInTransitTrip([]);
        setTrips([]);
      }
      console.log("Fetched driver trips:", response.data);
      setInTransitTrip(response.data.inTransitTrip);
      setTrips(response.data.completedTrips);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    setTransitStatus(e.target.value);
  };

  const handleEdit = (tripId, currentStatus, truckNumber) => {
    setEditingId(tripId);
    setTransitStatus(currentStatus || ""); // Handle undefined/null cases
    setTruckNumber(truckNumber || ""); // Handle undefined/null cases
  };

  const handleSave = async (tripId) => {
    try {
      const response = await axios.post(
        updateTransitStatusUrl,
        {
          tripId,
          transitStatus,
          truckNo,
        },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        },
      );

      console.log("response updates:", response.data);
      showModal("Success", "Transit status updated successfully.", "success");
      fetchTrips();
      // Update both inTransitTrip and trips states if needed
      // setInTransitTrip((prevTrips) =>
      //   prevTrips.map((trip) =>
      //     trip._id === tripId ? { ...trip, TransitStatus: transitStatus } : trip
      //   )
      // );

      // setTrips((prevTrips) =>
      //   prevTrips.map((trip) =>
      //     trip._id === tripId ? { ...trip, TransitStatus: transitStatus } : trip
      //   )
      // );

      setEditingId(null);
    } catch (err) {
      console.error("Update failed:", err);
      // Optionally show error to user
      showModal(
        "Error",
        "Failed to update transit status. Please try again.",
        "error",
      );
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if we're clicking outside any edit element
      if (editingId && !event.target.closest(".editing-row")) {
        console.log("Clicked outside editing row, cancelling edit");
        setEditingId(null);
        setTransitStatus("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingId]);

  // if (isLoading) {
  //   return (
  //     <div className="driver">
  //       <DriverNavbar />
  //       <div className="container-driver">
  //         <h1>Loading trips...</h1>
  //       </div>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div className="driver">
  //       <DriverNavbar />
  //       <div className="container-driver">
  //         <h1>Error: {error}</h1>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="driver">
      <DriverNavbar />
      <AlertModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
      {/* <div className="location-card">
        <form className="driverform">
          <div className="filterItem">
            <label htmlFor="source">Source:</label>
            <input
              type="text"
              id="source"
              name="source"
              value={formData.source}
            // onChange={handleInputChange}
            />
          </div>

          <div className="filterItem">
            <label htmlFor="destination">Destination:</label>
            <input
              type="text"
              id="destination"
              name="destination"
              value={formData.destination}
            // onChange={handleInputChange}
            />
          </div>

          <button className="submit-button" type="submit">
            Submit
          </button>
        </form>
      </div> */}
      <div className="container-driver">
        {isLoading ? (
          <div className="table-wrapper">
            <div className="spinner-container">
              <div className="spinner"></div>
              <p>Loading in-transit trips...</p>
            </div>
          </div>
        ) : (
          <div className="table-wrapper-transit">
            <h1>In-transit trip</h1>
            <br></br>
            <div className="table-container">
              <div className="table-responsive">
                <table id="resultsTable-transit">
                  <thead>
                    <tr>
                      <th>Trip ID</th>
                      <th>Transit Status</th>
                      <th>Truck Number</th>
                      <th>Vendor</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Truck Type</th>
                      <th>Weight</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inTransitTrip.length > 0 ? (
                      inTransitTrip.map((trip) => (
                        <tr
                          key={trip._id}
                          ref={editRefs[trip._id]}
                          className={
                            editingId === trip._id ? "editing-row" : ""
                          }
                        >
                          <td>{trip.TripID}</td>
                          <td>
                            {editingId === trip._id ? (
                              <div className="edit-container">
                                <select
                                  value={transitStatus}
                                  onChange={(e) =>
                                    setTransitStatus(e.target.value)
                                  }
                                  autoFocus // Focus immediately when editing
                                  className="status-select"
                                  disabled={[
                                    "Under Maintenance",
                                    "Breakdown",
                                    "Completed",
                                  ].includes(transitStatus)}
                                >
                                  <option value="">Select Status</option>
                                  <option value="Loading">Loading</option>
                                  <option value="Start">Start</option>
                                  <option value="Unloading">Unloading</option>
                                  <option value="Breakdown">Breakdown</option>
                                  <option value="Completed">Completed</option>
                                </select>
                              </div>
                            ) : (
                              // <div onClick={() => handleEdit(trip._id, trip.TransitStatus, trip.TruckNumber)}>
                              <div>{trip.TransitStatus}</div>
                            )}
                          </td>
                          <td>{trip.TruckNumber}</td>
                          <td>{trip.Vendor}</td>
                          <td>{trip.DestinationFrom}</td>
                          <td>{trip.DestinationTo}</td>
                          <td>{trip.TruckType}</td>
                          <td>{trip.Weight}</td>
                          <td>
                            {editingId === trip._id ? (
                              <div className="action-buttons">
                                <button
                                  className="save-btn"
                                  onClick={() => handleSave(trip.TripID)}
                                >
                                  Save
                                </button>
                              </div>
                            ) : (
                              <button
                                className="edit-btn"
                                onClick={() =>
                                  handleEdit(
                                    trip._id,
                                    trip.TransitStatus,
                                    trip.TruckNumber,
                                  )
                                }
                              >
                                Edit
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" style={{ textAlign: "center" }}>
                          No trips found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {isLoading ? (
          <div className="table-wrapper">
            <div className="spinner-container">
              <div className="spinner"></div>
              <p>Loading previous trips...</p>
            </div>
          </div>
        ) : (
          <div className="table-wrapper">
            <h1>Previous trips</h1>
            <br></br>
            <div className="scrollable-table">
              <table id="resultsTable">
                <thead>
                  <tr>
                    <th>Trip ID</th>
                    <th>Transit Status</th>
                    <th>Truck Number</th>
                    <th>Vendor</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Truck Type</th>
                    <th>Weight</th>
                    {/* <th>Edit</th> */}
                  </tr>
                </thead>
                <tbody>
                  {trips.length > 0 ? (
                    trips.map((trip) => (
                      <tr
                        key={trip._id}
                        // ref={editingId === trip._id ? editRef : null} // Attach ref when editing
                        // className={editingId === trip._id ? "editing-row" : ""}
                      >
                        <td>{trip.TripID}</td>
                        {/* <td>
                        {editingId === trip._id ? (
                          <div className="edit-container">
                            <select
                              value={transitStatus}
                              onChange={(e) => setTransitStatus(e.target.value)}
                              autoFocus // Focus immediately when editing
                              className="status-select"
                              disabled={["Under Maintenance", "Breakdown", "Completed"].includes(transitStatus)}
                            >
                              <option value="">Select Status</option>
                              <option value="Scheduled">Scheduled</option>
                              <option value="Loading">Loading</option>
                              <option value="Start">Start</option>
                              <option value="In-Transit">In-Transit</option>
                              <option value="Unloading">Unloading</option>
                              <option value="Vacant">Vacant</option>
                              <option value="Under Maintenance">Under Maintenance</option>
                              <option value="Breakdown">Breakdown</option>
                              <option value="Reserved">Reserved</option>
                              <option value="Completed">Completed</option>
                            </select>
                          </div>
                        ) : (
                          // <div onClick={() => handleEdit(trip._id, trip.TransitStatus, trip.TruckNumber)}>
                          <div>
                            {trip.TransitStatus || "None"}
                          </div>
                        )} */}
                        <td>{trip.TransitStatus || "None"}</td>
                        <td>{trip.TruckNumber}</td>
                        <td>{trip.Vendor}</td>
                        <td>{trip.DestinationFrom}</td>
                        <td>{trip.DestinationTo}</td>
                        <td>{trip.TruckType}</td>
                        <td>{trip.Weight}</td>
                        {/* <td>
                          {editingId === trip._id ? (
                            <div className="action-buttons">
                              <button
                                className="save-btn"
                                onClick={() => handleSave(trip._id)}
                              >
                                Save
                              </button>
                            </div>
                          ) : (
                            <button
                              className="edit-btn"
                              onClick={() => handleEdit(trip._id, trip.TransitStatus, trip.TruckNumber)}
                            >
                              Edit
                            </button>
                          )}
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center" }}>
                        No trips found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Driver;
